import { ServiceTypeEnum } from 'app/models';

export class RiderServiceTypeModel {
    public static RiderServiceTypeList: Array<any> = [
        { id: ServiceTypeEnum.Ride, name: 'Ride' },
        { id: ServiceTypeEnum.Delivery, name: 'Delivery' },
        { id: ServiceTypeEnum.Food, name: 'Food' },
        { id: ServiceTypeEnum.Grocery, name: 'Grocery' },
        { id: ServiceTypeEnum.Hire, name: 'Hire' },
        { id: ServiceTypeEnum.Transfer, name: 'Transfer' },
        { id: ServiceTypeEnum.ScanAndRide, name: 'Scan & Ride' },
        { id: ServiceTypeEnum.Single, name: 'Single' },
        { id: ServiceTypeEnum.Charter, name: 'Charter' },
        { id: ServiceTypeEnum.Taxi, name: 'Taxi' },
        { id: ServiceTypeEnum.DayTrip, name: 'Day Trip' },
        { id: ServiceTypeEnum.PublicTransport, name: 'Public Transport' },
        { id: ServiceTypeEnum.Experience, name: 'Experience' },
        { id: ServiceTypeEnum.Connex, name: 'Connex' }
    ];

    public static RiderServiceTypeShortList: Array<any> = [
        { id: ServiceTypeEnum.Ride, name: 'Ride' },
        { id: ServiceTypeEnum.Delivery, name: 'Delivery' },
    ];

    public static RiderServiceTypeXpressList: Array<any> = [
        { id: ServiceTypeEnum.None, name: 'All' },
        { id: ServiceTypeEnum.Ride, name: 'Ride' },
        { id: ServiceTypeEnum.Delivery, name: 'Delivery' },
        { id: ServiceTypeEnum.Food, name: 'Food' },
        { id: ServiceTypeEnum.Grocery, name: 'Grocery' },
        { id: ServiceTypeEnum.Hire, name: 'Hire' },
        { id: ServiceTypeEnum.Transfer, name: 'Transfer' }
    ];

    public static RiderServiceTypeBoracayList: Array<any> = [
        { id: ServiceTypeEnum.None, name: 'All' },
        { id: ServiceTypeEnum.Single, name: 'Single' },
        { id: ServiceTypeEnum.Charter, name: 'Charter' }
    ];
}
